export function ScopeNote({ children }: { children: string }) {
  return <p role="status" className="rounded-ks-sm border border-ks-purple/30 bg-ks-purple-4 px-3 py-2 text-xs text-ks-ink">{children}</p>;
}
